import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import DrugCategoryTable from "components/Table/List";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditDrugCategory from "./components/EditDrugCategory";
import TableAction from "components/Table/Actions/ActionDropdown";
import AddDrugCategory from "./components/AddDrugCategory";
import UploadCSV from "components/uploadCSV";
import SearchBox from "components/Filters/SearchBox";
import ShowModal from "components/Modal/ShowModal";
import { Tag } from "antd";

const Index = () => {
  const columns = [
    {
      title: "Name",
      render: (record) => <span>{record.drugCategoryName}</span>,
      key: "symptomName",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: 50,
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_DrugCategory_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteDrugCategory"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="drugCategoryList"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this drug category?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>DRUG CATEGORY</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654280791806-drugCategoryName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>

            <SearchBox
              apiName="getDrugCategory"
              recordName="drugCategoryList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getDrugCategory"
              url="bulkImportSkills"
              table="DrugCategory"
              recordName="drugCategoryList"
              cb="drugCategoryName"
              uId="drugCategoryId"
            />
            <AddDrugCategory />
          </div>
        }
      >
        <DrugCategoryTable
          apiName="getDrugCategory"
          recordName="drugCategoryList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditDrugCategory />
    </Layout>
  );
};
export default Index;
